<template>
  <b-tabs content-class="mt-3">
    <b-tab title="Lịch sử đơn hàng" active>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items" show-empty>
            <template #table-busy>
              <div class="text-center my-2 mt-5 mb-5">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Đang tải...</strong>
              </div>
            </template>

            <template #empty="scope">
              <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
            </template>

            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true">&check;</span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true">&nbsp;</span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>

            <template v-slot:cell(stt)="data">
              {{data.item.id}}
            </template>
            <template v-slot:cell(phone_number)="data">
              <span class="tel" @click="callPhone(data.item.customer.phone)">{{data.item.customer.phone}}</span>
            </template>
            <template v-slot:cell(customer_name)="data">
              {{data.item.customer.name}}
            </template>
            <template v-slot:cell(debt)="data">
              {{data.item.debt | format_currency}}
            </template>
            <template v-slot:cell(price)="data">
              {{data.item.price | format_currency}}
            </template>
            <template v-slot:cell(annual_debt)="data">
              {{data.item.annual_debt | format_currency}}
            </template>

          </b-table>
        </div>

        <div class="col-md-12 col-sm-12 col-xs-12 d-flex align-items-center justify-content-between">
          <div class="page-size-container">
            <span>Hiển thị</span>
            <b-form-select
              id="pageSize"
              v-model="pageSize"
              :options="pageSizes"
              required
            ></b-form-select>
            <span>  dòng</span>
          </div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRow"
            :per-page="pageSize"
            aria-controls="my-table"
          ></b-pagination>
        </div>
      </div>
    </b-tab>

    <b-tab title="Lịch sử phí theo lần mua mới">
      <OrderDetailHistory :orderId="orderId" type="NEW_BUY"></OrderDetailHistory>
    </b-tab>

    <b-tab title="Lịch sử phí mua thường niên">
      <OrderDetailHistory :orderId="orderId" type="ANNUAL_BUY"></OrderDetailHistory>
    </b-tab>
  </b-tabs>
</template>

<script>
import Box from '../../components/Box'
import Utils from '../../common/utils'
import OrderDetailApi from '../../api/orderDetailApi'
import {mapActions} from 'vuex'
import OrderDetailHistory from './OrderDetailHistory'

export default {
  name: 'DataHistory',
  components: {
    Box,
    OrderDetailHistory,
  },
  props: {
    orderId: {
      type: Number,
      required: false,
    }
  },
  data () {
    return {
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      fields: [
        {
          key: 'id',
          label: 'STT',
          show: true
        }, {
          key: 'phone_number',
          label: 'SĐT/Mã KH',
          show: true
        }, {
          key: 'customer_name',
          label: 'Thông tin khách hàng',
          show: true
        }, {
          key: 'customer_care_histories',
          label: 'Lịch sử chăm sóc',
          show: true
        }, {
          key: 'price',
          label: 'Giá tiền hợp đồng',
          show: true
        }, {
          key: 'debt',
          label: 'Công nợ',
          show: true
        }, {
          key: 'due_date',
          label: 'Ngày cần thanh toán công nợ',
          show: true
        }, {
          key: 'annual_debt',
          label: 'Công nợ định kỳ',
          show: true
        }, {
          key: 'annual_due_date',
          label: 'Ngày thanh toán công nợ định kỳ',
          show: true
        }, {
          key: 'pic',
          label: 'Nhân viên chăm sóc',
          show: true
        }, {
          key: 'updated_by',
          label: 'Người thực hiện',
          show: true
        }
      ],
      items: []
    }
  },
  mounted () {
    if (this.orderId) {
      this.filter()
    }
  },
  methods: {
    ...mapActions([
      'changePhoneNumber'
    ]),
    buildFilterData () {
      return {order_id: this.orderId}
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      OrderDetailApi.filter_order_history(this.buildFilterData(), this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    edit (id) {

    },
    remove (id) {

    },
    callPhone (phoneNumber) {
      this.changePhoneNumber({phoneNumber: phoneNumber})
      this.$bvModal.show('phone-call-modal')
    }
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order_management/DataHistory.vue